<template>
  <el-dialog :title="form.title" :visible.sync="dialogFormVisible" custom-class="max-dialog1256" center :append-to-body="true"
             :close-on-click-modal="false"
  >
    <div id="BodyControls" runat="server">
      <ul>
        <!--<li style="text-align: center">-->
          <!--<span v-html="form.title"></span>-->
        <!--</li>-->
        <li style="text-align: center; background-color: #e6e6e6; line-height: 30px; height: 30px;">【 <span v-html="form.dname"></span>-<span v-html="form.uname"></span> 】
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span v-html="(form.startdate|| '').substr(0, 10)"></span>

          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          阅读次数：<span v-html="form.visittimes"></span>
        </li>
        <li>
          <div v-html="form.inforcontent" style="font-size: 16px; width: 1002px; margin-left: 130px; margin-top: 5px" runat="server">
          </div>
        </li>
        <li style="padding-left: 100px; line-height: 28px;padding-top:20px;" v-if="form.attguid">
          <CommonUpload ref="refattguid" :multiple="true" :groupGuid="form.attguid" :disabled="true"
                        groupType="inforlist" :limit="10"></CommonUpload>
        </li>
      </ul>
    </div>

    <div slot="footer" class="dialog-footer">
      <InforEdit ref="InforEdit" @bindInfoList="AfterEdit"></InforEdit>
      <el-button v-if="CanEdit&&this.form.unitguid" type="danger" @click="handleDelete()">删 除</el-button>
      <el-button v-if="CanEdit&&this.form.unitguid" type="primary" @click="handleEdit()">修 改</el-button>
      <el-button @click="hide()">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {saveData,getDetail,saveLogData,deleteData} from '@/api/oa/inforlist';
  import InforEdit from './InforEdit';

  export default {
    name: 'InforDetail',
    data() {
      return {
        dialogFormVisible:false,
        CanEdit:false,
        nofile:false,
        form: {
          unitguid:"",
          title: "",
          attguid: "",
          dname: "", uname: "", startdate: "", visittimes: "", inforcontent: "",classcode:""
        }
      }
    },
    methods: {
      handleEdit() {
        this.$refs.InforEdit.show(this.form.classcode,'修改信息');
        this.$refs.InforEdit.initData(this.form.unitguid);
      },
      handleDelete(){
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteData({unitguid: this.form.unitguid}).then(response => {
            if (response.data.code == 0) {
              this.$emit('bindInfoList',this.form.classcode);
              this.dialogFormVisible=false;
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: response.data.msg
              });
            }

          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      AfterEdit() {
        if(this.$refs.refattguid){
          this.$refs.refattguid.bindData();
        }
        this.$emit('bindInfoList', this.form.classcode);
        this.initData(this.form.unitguid);
      },
      initData(unitguid){
        this.CanEdit=false;
        getDetail({unitguid: unitguid}).then(response => {
          this.form = response.data.obj;
          if (response.data.obj.selfvisittimes == 0) {
            //增加访问日志
            saveLogData({inforguid: unitguid}).then(response => {});
          }
          this.CanEdit=response.data.canedit;
          this.dialogFormVisible = true;
        });
      },

      show(customerserial,statuses){
        this.dialogFormVisible=true
      },
      hide(){
        //刷新列表
        this.$emit('bindGrid');
        this.dialogFormVisible=false;

      }

    },
    mounted() {

    },
    components: {
      InforEdit
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/oa/inforlist/InforDetail.vue